export const logoutChannel = new BroadcastChannel('logout_channel');
